import { useState } from 'react';

import ComponentModal from '../../../reusable/component-modal/component-modal.component';

import { api } from '../../../../config.js';

import {
    ProductImageContainer,
    ProductImg,
    ProductImgEnlarged,
    ImageCaption,
    ImageActions,
    DeleteButton,
    PrimaryTag
} from './product-image.styles';

const ProductImage = ({ image, deleteImage }) => {
    const [ showImage, setShowImage ] = useState(false);
    
    return (
        <>
            <ComponentModal
                isOpen={showImage}
                onClose={() => setShowImage(false)}
                title="Product Image"
            >
                <ProductImageContainer>
                    <ProductImgEnlarged src={api + image.path} />
                    {image.caption && <ImageCaption>{image.caption}</ImageCaption>}
                    <ImageActions>
                        <DeleteButton onClick={() => deleteImage(image.id)}>Delete</DeleteButton>
                        {image.isPrimary && <PrimaryTag>Primary</PrimaryTag>}
                    </ImageActions>
                </ProductImageContainer>
            </ComponentModal>

            <ProductImg onClick={() => setShowImage(true)} src={api + image.path} />

            
        </>
    )
};

export default ProductImage;